import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Every navigation starts at the top.
 *
 * A single-page app keeps the scroll position across a route change, which is
 * right when going *back* and wrong every other time. Opening the fortieth
 * product in a long grid dropped the operator halfway down the editor — usually
 * into the middle of the specifications table — with the title, the tabs and the
 * save button all above the fold and no clue that they were there.
 *
 * Scoped to a genuine change of page: a query-string edit is the table sorting,
 * filtering or paging itself, and yanking somebody to the top every time they
 * change a filter is its own small hostility. So this watches `pathname` only.
 *
 * `instant` rather than smooth. The page has already changed; animating the
 * scroll of content that is no longer there just delays the new screen.
 */
export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // A hash means the destination is somewhere specific on the page; jumping to
    // the top would undo the browser's own anchor scroll. The storefront makes
    // the same exception.
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
